import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { IntegrationFormSchema } from '../schemas';
import { z } from 'zod';

export const HomeAssistantIntegrationFormSchema = z
  .object({
    homeAssistantBaseUrl: z
      .string({ message: MANDATORY_FIELD })
      .nonempty({ message: MANDATORY_FIELD }),
    homeAssistantAccessToken: z
      .string({ message: MANDATORY_FIELD })
      .nonempty({ message: MANDATORY_FIELD }),
  })
  .merge(IntegrationFormSchema);
